'use strict';

angular.module('cf.utils')
.factory('require', ['$injector', $injector => $injector.get]);



// WEBPACK FOOTER //
// ./src/javascripts/utils/require.js